import React from 'react';
import { RecipeTimeProps } from '@views/RecipeDetailPage/_RecipeHero';

import useTranslation from '@repo/ui/src/context/Translation/useTranslation';

interface InlineCardProps {
  title: string;
  prepTime: Array<RecipeTimeProps>;
  cookTime: Array<RecipeTimeProps>;
  hardwood: string;
  servingSizeMin: number;
  description: string;
}
const InlineRecipeCardInfo = ({
  servingSizeMin,
  hardwood,
  cookTime,
  prepTime,
}: InlineCardProps) => {
  const { t } = useTranslation();

  return (
    <div className="tw-grid tw-grid-cols-2 tw-gap-y-5 md:tw-flex md:tw-flex-row tw-pt-10">
      {!!prepTime.length && (
        <div className="tw-flex tw-flex-col tw-items-center tw-w-full tw-border-r last:tw-border-r-0">
          <p className="tra-text-web-body-m tw-text-left tw-mb-0">
            {t('recipeContent.prepTimeLabel')}
          </p>
          <div className="tw-grid tw-grid-flow-col tw-gap-2">
            {prepTime?.map(({ label, value }, i) => (
              <h5 className="tra-text-web-heading-6 tw-text-left" key={i}>
                {value} {label}{' '}
              </h5>
            ))}
          </div>
        </div>
      )}
      {!!cookTime.length && (
        <div className="tw-flex tw-flex-col tw-items-center tw-border-r last:tw-border-r-0 tw-w-full">
          <p className="tra-text-web-body-m tw-text-left tw-mb-0">
            {t('recipeContent.cookTimeLabel')}
          </p>
          <div className="tw-grid tw-grid-flow-col tw-gap-2">
            {cookTime?.map(({ label, value }, i) => (
              <h5 className="tra-text-web-heading-6 tw-text-left" key={i}>
                {value} {label}{' '}
              </h5>
            ))}
          </div>
        </div>
      )}
      {servingSizeMin && (
        <div className="tw-flex tw-flex-col tw-items-center tw-border-r last:tw-border-r-0 tw-w-full">
          <p className="tra-text-web-body-m tw-text-left tw-mb-0">
            {t('recipeContent.servesLabel', undefined, { default: 'serves' })}
          </p>
          <h6 className="tra-text-web-heading-6 tw-text-left">{servingSizeMin}</h6>
        </div>
      )}
      {hardwood && (
        <div className="tw-flex tw-flex-col tw-items-center tw-w-full">
          <p className="tra-text-web-body-m tw-text-left tw-mb-0">
            {t('recipeContent.pelletsLabel')}
          </p>
          <h6 className="tra-text-web-heading-6">{hardwood}</h6>
        </div>
      )}
    </div>
  );
};

export default InlineRecipeCardInfo;
